<template>
  <Modal title="Удаление записи" @backdrop-click="close">
    <template slot="body">
      <div class="body__wrapper">
        <div v-if="conflictProducts.length > 0" class="wrapper__block_conflict">
          <p>
            Удаление было отменено ввиду конфликта. Для его устранения
            уберите связь между удаляемой записью и
            продуктами ниже. После этого, пожалуйста, повторно подтвердите удаление
          </p>
          <div class="block__list">
            <RouterLink
              v-for="item, index in conflictProducts"
              :key="item.id"
              :to="`/products/${item.id}`"
              target="_blank"
              class="list__item"
            >
              {{ `${index + 1})` }} {{ item.name }}
            </RouterLink>
          </div>
        </div>
        <p v-else>Вы действительно желаете удалить запись?</p>
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <button
          v-focus
          type="button"
          :disabled="isRemoving"
          class="modal-default-button btn btn-danger"
          @click.stop="close"
        >
          Отменить
        </button>
        <button
          type="button"
          :disabled="isRemoving"
          class="modal-default-button btn btn-success"
          @click.stop="confirm"
        >
          Подтвердить
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
import { useNotification } from '@/_shared/mixins';
export default {
  mixins: [useNotification],
  components: {
    Modal,
  },
  props: {
    removalCallback: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isRemoving: false,
      conflictProducts: [],
    };
  },
  emits: ["close"],
  watch: {
    show: {
      handler(value) {
        if (value) {
          document.querySelector("body").style.overflow = "hidden";
        }
      },
      immediate: true,
    },
  },
  methods: {
    async confirm() {
      this.isRemoving = true;
      await this.removalCallback()
        .then(({ data }) => {
          if (data.conflictProducts.length > 0) {
            this.conflictProducts = data.conflictProducts;
            return;
          }
          const tableName = this.$route.path.split('/').filter((value) => !!value)[0];
          this.$router.push(`/${tableName}`);
          this.close();
          this.showSuccessNotification('Запись была успешно удалена');
        })
        .finally(() => {
          this.isRemoving = false;
        });
    },
    close() {
      if (!this.isRemoving) {
        document.querySelector("body").style.overflow = "auto";
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped>
.wrapper__body,
.wrapper__block_conflict {
  max-width: 400px;
}
.block__list {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;
}
.list__item {
  width: fit-content;
}
.list__item:not(:first-child) {
  margin-top: 12px;
}
@media (max-width: 419px) {
  .body__wrapper {
    text-align: center;
  }
  .modal__buttons {
    flex-direction: column-reverse;
    padding: 0 4vw;
  }
  .modal-footer .btn + .btn {
    margin: 0 0 12px 0;
  }
  .buttons__button_close-modal {
    margin-bottom: 1em;
  }
  .modal__buttons > div > button {
    width: 100%;
    max-width: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/modals/RecordRemovalModal.vue